"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Persona: function() {
        return _index.Persona;
    },
    personaClassNames: function() {
        return _index.personaClassNames;
    },
    renderPersona_unstable: function() {
        return _index.renderPersona_unstable;
    },
    usePersonaBase_unstable: function() {
        return _index.usePersonaBase_unstable;
    },
    usePersonaStyles_unstable: function() {
        return _index.usePersonaStyles_unstable;
    },
    usePersona_unstable: function() {
        return _index.usePersona_unstable;
    }
});
const _index = require("./components/Persona/index");
